import React, { FC, useCallback, useMemo } from 'react';
import { DatePicker } from 'antd';
import dayjs from 'dayjs';
import { Constants } from '@shared/constants';

const { RangePicker } = DatePicker;

export const NextTableDateFilter: FC<any> = ({ column: { filterValue, setFilter } }) => {
  const value = useMemo(() => {
    if (filterValue) {
      return filterValue.split(',').map((date) => dayjs(date, Constants.DATE_TIME));
    }
  }, [filterValue]);

  const handleChange = useCallback(
    (value) => {
      if (value instanceof Array) {
        setFilter(value.map((date) => dayjs(date).format(Constants.DATE_TIME)).join(','));
      } else {
        setFilter(undefined);
      }
    },
    [setFilter],
  );

  return <RangePicker showTime={true} onChange={handleChange} value={value} format={Constants.DATE_TIME} />;
};
